import React from "react";
import { useNavigate } from "react-router-dom";
import ClientsComboBox from "Components/Client/ClientsComboBox";

//MUI
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

export default function EndcustomerFormContact({
  endcustomer,
  FORM_MODE,
  handleInputChange,
}) {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            disabled={FORM_MODE === "LOCKED" ? true : false}
            name="PhoneNumber"
            label="Telefonnummer"
            value={endcustomer.TelephoneNumber}
            onChange={(e) =>
              handleInputChange("TelephoneNumber", e.target.value)
            }
            size="small"
            color="primary"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="ContactEmail"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="Kontakt E-post"
            value={endcustomer.ContactEmail}
            onChange={(e) => handleInputChange("ContactEmail", e.target.value)}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="InvoiceEmail"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="E-post faktura"
            value={endcustomer.InvoiceEmail}
            onChange={(e) => handleInputChange("InvoiceEmail", e.target.value)}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="ReminderEmail"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="E-post påminnelser"
            value={endcustomer.ReminderEmail}
            onChange={(e) => handleInputChange("ReminderEmail", e.target.value)}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
          />
        </Grid>
      </Grid>
    </>
  );
}

/*
    ExternalCustomerNr: endcustomer.ExternalCustomerNr,
    ID: endcustomer.ID,
*/
